module.exports = __webpack_public_path__ + "img/no_user.3c4d0a75.svg";